import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const BusinessProfile = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  //admin user information
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //company information
  const [companyName, setCompanyName] = useState("");
  const [companySlogan, setCompanySlogan] = useState("");
  const [companyContactNumber, setCompanyContactNumbe] = useState("");

  const [companyEmail, setCompanyEmail] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyDescription, setCompanyDescription] = useState("");
  const [companyServiceArray, setCompanyServicesArray] = useState(null);
  //services

  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [imageData, setImageData] = useState(null);

  const [file, setFile] = useState(null);

  const [previewUrl, setPreviewUrl] = useState(null);

  const [stateCheck, setStateCheck] = useState(false);

  const [logoLink, setLogoLink] = useState(null);

  const [imageError, setImageError] = useState("");

  const [type, setType] = useState("business");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  console.log("company info", companyInformation);

  const EditQty = ({ idIndex }) => {
    const array = [...companyServiceArray];

    //find index of item to be replaced
    const targetIndex = companyServiceArray.findIndex(
      (f, index) => index === idIndex
    );

    //replace the object with a new one.
    if (array[targetIndex].value === true) {
      array[targetIndex].value = false;
    } else {
      array[targetIndex].value = true;
    }
    setStateCheck(stateCheck ? false : true);
    // console.log("calcutlate check trigger", recieptList);
  };
  const ReturnArrayRecieptArray = () => {
    return companyServiceArray;
  };
  const UpdateCompanyData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        // process.env.REACT_APP_BACKEND_URL + "/agency/agencyAdminUpdateData",
        "https://driverfrienddatabase-h2aa.onrender.com/agency/agencyAdminUpdateData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            companyId: auth.companyId,
            documentId: companyInformation._id,

            // company information
            companyName: companyName,
            companySlogan: companySlogan,
            companyEmail: companyEmail,
            companyContactName: companyInformation.companyContactName,
            companyContactNumber: companyInformation.companyContactNumber,
            companyAddress: companyAddress,
            companyDescription: companyDescription,
            companyDocsReg: "none",
            companyDocsVat: "none",
            companyWebsite: companyWebsite,
            imageId: "none",
            type: type,
            //services
            companyServices: companyServiceArray,
            status: type === "business" ? "" : "PENDING APPROVAL",
          }),
        }
      );

      const respnseData = await response.json();
      console.log("response update data", respnseData);
      if (respnseData.success) {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(respnseData.success);
        setLoading(false);
        setRefresh(refresh ? false : true);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(err);
      setPopUpTitle("FAILED");
      setToastPop(true);
    }
  };
  // const updateBusinessInfo = async (e) => {
  //   setLoading(true);

  //   if (!validFileTypes.find((type) => type === file.type)) {
  //     setImageError("File type must be JPG or PNG format");
  //     return;
  //   } else {
  //     setImageError("");
  //     setImageData(file);
  //   }
  //   try {

  //     const formData = new FormData();

  //     companyName,
  //     companySlogan,
  //     companyEmail,
  //     companyContactName,
  //     companyContactNumber,
  //     companyAddress,
  //     companyDescription,
  //     companyDocsReg,
  //     companyDocsVat,
  //     companyWebsite,
  //     teamMembers,
  //     //services
  //     companyServices,
  //     formData.append("image", file);
  //     formData.append("companyId",auth.companyId );
  //     formData.append("userId", auth.userId);
  //     formData.append("documentId", companyInformation._id);
  //     formData.append("status", "APPROVED");
  //     formData.append("shortDescription", longDescription.substring(0, 50));
  //     formData.append("longDescription", longDescription);
  //     formData.append("postType", postArray);
  //     formData.append("tags", CreateTagsArray());
  //     formData.append("sourceLink", sourceLink);
  //     formData.append(
  //       "creationApprovedBy",
  //       auth.customerUserData.firstName + " " + auth.customerUserData.lastName
  //     );
  //     formData.append(
  //       "editedBy",
  //       auth.customerUserData.firstName + " " + auth.customerUserData.lastName
  //     );

  //     const response = await fetch(
  //       "https://driverfrienddatabase-h2aa.onrender.com/agency/agencyAdminUpdateData",
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );
  //     const respnseData = await response.json();

  //     if (respnseData.success) {
  //       setCreatePostModal(false);
  //       setToastPop(true);
  //       setMessage(respnseData.success);
  //       setPopUpTitle("SUCCESS");
  //       setLoading(false);
  //       setRefresh(refresh ? false : true);

  //       // setVehicleSearchArray(respnseData.enatisVehicles);
  //     } else {
  //       setToastPop(true);
  //       setMessage(respnseData.error);
  //       setPopUpTitle("FAILURE");
  //       setLoading(false);
  //     }
  //   } catch (err) {
  //     setLoading(false);
  //     console.log("error", err);
  //   }
  // };
  useEffect(() => {
    if (!file) {
      //   if (!sigfile) {
      //     return;
      //   }
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);

  useEffect(() => {
    ReturnArrayRecieptArray();
  }, [stateCheck]);

  useEffect(() => {
    if (companyInformation) {
      setCompanyName(companyInformation.companyName);
      if (companyInformation.companySlogan) {
        setCompanySlogan(companyInformation.companySlogan);
      }
      setCompanyDescription(companyInformation.companyDescription);
      setCompanyContactNumbe(companyInformation.companyContactNumber);
      setCompanyEmail(companyInformation.companyEmail);
      setCompanyAddress(companyInformation.companyAddress);
      setCompanyWebsite(companyInformation.companyWebsite);
      setCompanyServicesArray(companyInformation.companyServices);
    }
  }, []);
  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
      <div
        style={{
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "90%",
            marginTop: 20,
            fontWeight: "bold",
            fontSize: 18,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              minWidth: 10,
              minHeight: 10,
              borderRadius: 100,
              backgroundColor: colors.secondaryDarkBlue,
              marginRight: 10,
            }}
          />
          BASIC INFORMATION
        </div>
        <div
          style={{
            display: "flex",
            width: "90%",

            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              flex: 0.3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                minHeight: 200,
                minWidth: 200,
                backgroundColor: logoLink
                  ? logoLink
                  : previewUrl
                  ? null
                  : "#00000050",
                borderRadius: 8,
                marginTop: 30,
                marginRight: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="Preview"
                src={logoLink ? logoLink : previewUrl ? previewUrl : null}
                style={{ maxHeight: 150, maxWidth: 150 }}
              />
            </div>
          </div>
          <div
            style={{
              flex: 0.7,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <TextInputField
              labelTitle={"COMPANY NAME"}
              mini={true}
              width={"100%"}
              size={"90%"}
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
            <TextInputField
              labelTitle={"COMPANY SLOGAN"}
              mini={true}
              width={"100%"}
              size={"90%"}
              value={companySlogan}
              onChange={(e) => setCompanySlogan(e.target.value)}
            />
            <ImageUploadAWS
              mini={true}
              height={20}
              labelTitle={"UPLOAD LOGO"}
              width={"100%"}
              size={"90%"}
              onChange={(e) => handleFileChange(e)}
              errorDisplay={imageError}
            />
          </div>
        </div>

        <TextInputFieldArea
          labelTitle={"SHORT DESCRIPTION"}
          height={150}
          mini={true}
          width={"90%"}
          size={"93%"}
          value={companyDescription}
          onChange={(e) => setCompanyDescription(e.target.value)}
        />
        <TextInputField
          labelTitle={"CONTACT PERSON ( READ ONLY )"}
          mini={true}
          width={"93%"}
          size={"90%"}
          readOnly={true}
          value={
            companyInformation
              ? companyInformation.companyContactName
              : "loading"
          }
        />
        <TextInputField
          labelTitle={"CONTACT NUMBER"}
          mini={true}
          width={"93%"}
          size={"90%"}
          value={companyContactNumber}
          onChange={(e) => setCompanyContactNumbe(e.target.value)}
        />
        <TextInputField
          labelTitle={"CONTACT EMAIL"}
          mini={true}
          width={"93%"}
          size={"90%"}
          value={companyEmail}
          onChange={(e) => setCompanyEmail(e.target.value)}
        />
      </div>
      <div
        style={{
          flex: 0.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "90%",
            marginTop: 20,
            fontWeight: "bold",
            fontSize: 18,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              minWidth: 10,
              minHeight: 10,
              borderRadius: 100,
              backgroundColor: colors.secondaryDarkBlue,
              marginRight: 10,
            }}
          />
          IMPORTANT INFORMATION:
        </div>
        <TextInputField
          labelTitle={"WEBSITE"}
          mini={true}
          width={"93%"}
          size={"90%"}
          value={companyWebsite}
          onChange={(e) => setCompanyWebsite(e.target.value)}
        />
        <TextInputFieldArea
          labelTitle={"COMPANY ADDRESS"}
          height={100}
          mini={true}
          width={"90%"}
          size={"93%"}
          value={companyAddress}
          onChange={(e) => setCompanyAddress(e.target.value)}
        />

        <div
          style={{
            width: "90%",
            marginTop: 30,
            fontWeight: "bold",
            fontSize: 18,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              minWidth: 10,
              minHeight: 10,
              borderRadius: 100,
              backgroundColor: colors.secondaryDarkBlue,
              marginRight: 10,
            }}
          />
          SERVICES YOU OFFER:
        </div>
        {companyInformation.type === "business" && type === "business" ? (
          <div
            style={{
              minHeight: 270,
              maxHeight: 270,
              width: "100%",
              // flexWrap: "wrap",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            normal business services options and a button to request to cahnge
            to agnecy
            <div>
              <BaseButtons
                label={"REQUEST TO BE AGENCY"}
                backgroundColor={colors.secondaryDarkBlue}
                borderRadius={8}
                onClick={() => setType("Agency")}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              minHeight: 270,
              maxHeight: 270,
              width: "100%",
              flexWrap: "wrap",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {companyServiceArray
              ? companyServiceArray.map((service, index) => {
                  return (
                    <div key={index} style={{ width: "45%", maxHeight: 40 }}>
                      <CheckInput
                        label={service.serviceType}
                        selected={service.value}
                        onClick={() => EditQty({ idIndex: index })}
                      />
                    </div>
                  );
                })
              : "loading"}
          </div>
        )}
        <div style={{ minHeight: 20 }} />
        <BaseButtons
          label={"VIEW TERMS AND CONDITIONS"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          width={"90%"}
        />
        <div style={{ minHeight: 20 }} />
        <BaseButtons
          // disabled={
          //   companyName !== companyInformation.companyName ||
          //   companySlogan !== companyInformation.companySlogan ||
          //   companyDescription !== companyInformation.companyDescription ||
          //   file
          //     ? false
          //     : true
          // }
          label={"SAVE"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
          width={"90%"}
          onClick={() => UpdateCompanyData()}
        />
      </div>
    </div>
  );
};

export default BusinessProfile;
